var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 29,
    r: 3,
    fill: "#D8D8D8",
    stroke: "#979797"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 56,
    x: 1.5,
    y: 1.5,
    fill: "#FFF",
    stroke: "#EAECF6",
    strokeWidth: 3,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#EAECF6",
    strokeWidth: 3,
    d: "M55.5 36.5v-17H34a8.5 8.5 0 1 0 0 17h21.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 27.5,
    r: 3.5,
    fill: "#EAECF6"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#EAECF6",
    d: "M67.682 49.357c0-8.284-6.716-14.999-15.002-14.999-8.283 0-14.998 6.716-14.998 15 0 8.284 6.716 15 14.998 15 8.285 0 15.002-6.716 15.002-15z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#C4C9D9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.39 45.197l-9.193 9.192M47.904 45.404l9.192 9.192"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWallet);
export default __webpack_public_path__ + "static/media/no-wallet.01eea23cada6f6b4a2af61b85c9999c9.svg";
export { ForwardRef as ReactComponent };